import { useState } from "react";

interface DateTabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

export default function DateTabs({ activeTab, onTabChange }: DateTabsProps) {
  const [dateStrings] = useState(() => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const fmt = (d: Date) => `${d.getMonth() + 1}월 ${d.getDate()}일`;

    return {
      todayStr: fmt(today),
      tomorrowStr: fmt(tomorrow),
      yesterdayStr: fmt(yesterday),
    };
  });

  const tabs = [
    { id: "yesterday", label: "어제", date: dateStrings.yesterdayStr },
    { id: "today", label: "오늘", date: dateStrings.todayStr },
    { id: "tomorrow", label: "내일", date: dateStrings.tomorrowStr },
  ];

  return (
    <div className="mb-8">
      <div className="flex items-center gap-2 bg-dark-surface rounded-xl p-1.5 border border-dark-border">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`flex-1 flex flex-col items-center py-2.5 px-4 rounded-lg text-sm font-medium transition-all cursor-pointer ${
              activeTab === tab.id
                ? "bg-brand-orange text-white shadow-lg"
                : "text-dark-text-muted hover:text-white"
            }`}
          >
            <span className="text-xs opacity-70">{tab.label}</span>
            <span className="text-sm font-bold">{tab.date}</span>
          </button>
        ))}
      </div>
    </div>
  );
}